/**
 * A drop's time on the Day timeline: Danish first from the drop's instant
 * (with −1d / +1d against the country's date), the country's time under it,
 * and the date pill past midnight (moved out of TimelineRow, 19/10/2026).
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';

import { Badge } from '@/components/ui';

import type { DayPlanDropRow } from '../../../drop-generator.types';
import { dateMark, instantDk } from '../../../utils/clock/dk-label';
import { minutesLabel } from '../../../utils/format';
import { useCountryClock } from '../../shared/time/country-clock-context';

const ddmm = (iso: string) => `${iso.slice(8, 10)}/${iso.slice(5, 7)}`;

export const TimeCell: FC<{ drop: DayPlanDropRow; runDate: string; recipientTimezone: string | null }> = ({ drop, runDate, recipientTimezone }) => {
  const { flag } = useCountryClock();
  const dk = recipientTimezone ? instantDk(drop.atUtc) : null;
  const pill = drop.workDate !== runDate ? <Badge tone="secondary">{ddmm(drop.workDate)}</Badge> : null;
  if (!dk)
    return (
      <span className="flex items-center gap-1.5 font-mono text-xs tabular-nums">
        {minutesLabel(drop.minute)}
        {pill}
      </span>
    );
  return (
    <span className="flex flex-col font-mono text-xs leading-tight tabular-nums">
      <span className="whitespace-nowrap">
        <span className="font-semibold text-foreground">{dk.label}</span>
        <span className="ml-1 text-[10px]">🇩🇰</span>
        <span className="text-[10px] text-muted-foreground">{dateMark(dk.date, drop.workDate)}</span>
      </span>
      <span className="flex items-center gap-1.5 whitespace-nowrap text-[10.5px] text-muted-foreground">
        {flag} {minutesLabel(drop.minute)}
        {pill}
      </span>
    </span>
  );
};
